/* Redux */
import { useSelector, useDispatch } from 'src/redux/hooks'

const Redux = () => {
  const searchOpen = useSelector(store => store.App.showMobileSuche)
  const open = useSelector(store => store.App.showNavigationDrawer)
  
  const dispatch = useDispatch()

  const toggle = (event: React.KeyboardEvent | React.MouseEvent) => {
    if (
      event.type === 'keydown' &&
      ((event as React.KeyboardEvent).key === 'Tab' || (event as React.KeyboardEvent).key === 'Shift')
    ) return

    dispatch({ type: 'navigationDrawerToggle', payload: false })
  }

  return { open, toggle, searchOpen }
}

export default Redux